import React, { Component } from "react";
import { MdMoreHoriz, MdEdit } from "react-icons/md";
import COLORS from "scss/colors.module.scss";
import { BsThreeDotsVertical } from "react-icons/bs";
import { DIMENSIONS } from "utils/Dimensions";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import styled from "styled-components";
import RenameSheetDialog from ".../../app/common/LeftHoverMenu/components/RenameSheetDialog";
import { values } from "lodash";
import ApiClient from "utils/ApiClient";
import DeleteIcon from '@material-ui/icons/Delete';
import { IoMdCheckbox } from "react-icons/io";
import { AiFillEdit } from "react-icons/ai";

const Sheet_Options = {
  EDIT: "Edit Report",
  DELETE: "Delete Report",
  RENAME: "Rename Report",
  MARK_AS_DEFAULT_REPORT: "Mark as Default Report",
  RENAME_SHEET: "Rename Sheet",
};
export default class SheetActions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      actions: [Sheet_Options.EDIT, Sheet_Options.DELETE, Sheet_Options.RENAME, Sheet_Options.MARK_AS_DEFAULT_REPORT],
      anchorEl: null,
      isNameEditing: false,
    };
  }

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    let  sheetOptions = [Sheet_Options.EDIT, Sheet_Options.DELETE, Sheet_Options.RENAME, Sheet_Options.MARK_AS_DEFAULT_REPORT];
    if(this.props.view.is_main_view == 1){
      sheetOptions = [Sheet_Options.RENAME_SHEET, Sheet_Options.MARK_AS_DEFAULT_REPORT];
    }
    return (
      <StyledRowHeightDiv className="d-flex actions">
        <BsThreeDotsVertical
          size={18}
          color={COLORS.TEXT_COLOR}
          data-tip="Sheet Action"
          data-for="sheetAction"
          onClick={this.handleClick}
        />
        <Menu
          id="simple-menu"
          anchorEl={this.state.anchorEl}
          keepMounted
          open={Boolean(this.state.anchorEl)}
          onClose={this.handleClose}
          getContentAnchorEl={null}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          {sheetOptions.map((action, index) => (
            <MenuItem
              key={index}
              className={"sheetActions"}
              onClick={async () => {
                this.handleClose();
                if (action == Sheet_Options.RENAME || action == Sheet_Options.RENAME_SHEET) {
                  this.props.renameView();
                } else if(action == Sheet_Options.MARK_AS_DEFAULT_REPORT) {
                  try {
                    await window.appStore.notificationStore.confirm({
                      title: <>Mark as Default Report</>,
                      description: (
                        <>Do you want to mark this view as default for you?</>
                      ),
                    });
                    this.props.handleMarkasDefaultReport(this.props.view.id);
                  } catch (e) {
                    console.log(e);
                  }
                } else if (action == Sheet_Options.EDIT) {
                  this.props.handleEditReport(this.props.view.id);
                } else if (action == Sheet_Options.DELETE) {
                  try {
                    await window.appStore.notificationStore.confirm({
                      title: <>Delete Report</>,
                      description: (
                        <>Are you sure you want to delete this report?</>
                      ),
                    });
                    this.props.deleteView(this.props.view.id);
                  } catch (e) {
                    console.log(e);
                  }
                }
              }}
            >
              {action == Sheet_Options.EDIT && (
                <AiFillEdit style= {styles.icon} size={18} />
              )}
              {action == Sheet_Options.DELETE && (
                <StyledDeleteIcon style= {styles.icon} />
              )}
              {(action == Sheet_Options.RENAME || action == Sheet_Options.RENAME_SHEET) && (
                <MdEdit style= {styles.icon} size={18} />
              )}
              {action == Sheet_Options.MARK_AS_DEFAULT_REPORT && (
                <IoMdCheckbox style= {styles.icon} size={18} />
              )}
              <div style= {styles.text}>{action}</div>
            </MenuItem>
          ))}
        </Menu>
      </StyledRowHeightDiv>
    );
  }
}

const styles = {
  icon: {
    //marginTop: -5,
    marginLeft: -5,
    marginRight: -15,
  },
  text:{
    marginLeft: 20
  }
};
const StyledRowHeightDiv = styled.div`
  margin: 3px;
  border-radius: 4px;
  padding: 3px;
  cursor: pointer;
  align-items: center;
`;
const StyledDeleteIcon = styled(DeleteIcon)`
&& {
  width: 18px;
  height: 18px;
  color: #000000;
}
`;